var fails = require('../internals/fails');
var global = require('../internals/global');

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/regexp-unsupported-dot-all.js
// module id = 129
// module chunks = 0